import { render, staticRenderFns } from "./VideoDetailDrawer.vue?vue&type=template&id=8f22fcb6&scoped=true"
import script from "./VideoDetailDrawer.vue?vue&type=script&lang=js"
export * from "./VideoDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./VideoDetailDrawer.vue?vue&type=style&index=0&id=8f22fcb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f22fcb6",
  null
  
)

export default component.exports